<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 2.main-container-start -->
    <div class="main">
      <div class="top">
        <img v-if="logoImg != ''" :src="logoImg" class="logopic" /><img
          v-else
          src="../../image/logo.png"
          class="logopic"
        />
        <span v-html="cozyTip" class="df-log-a"></span>
      </div>
      <div class="df-logm" :style="mainBg">
        <!--<div v-if="isLeft" class="left">
          <img v-if="leftImg != ''" :src="leftImg" class="img" /><img
            v-else
            src="../../images/bg2.png"
            class="img"
          />
        </div>-->
        <div class="df-logmm">
          <div class="df-logmm-box">
            <div class="df-logmm-box-a">
              <img v-if="logoImg != ''" :src="logoImg" class="logopic" /><img
                v-else
                src="../../image/logo.png"
                class="logopic"
              />
            </div>
            <div class="df-logmm-box-b">
              <span>密码登录</span>
            </div>
            <!-- <div class="top">{{ title }}</div> -->
            <div class="df-logmm-box-inp">
              <div class="left">
                <img src="../../image/uesr.png" class="img" />
              </div>
              <input
                v-model="username"
                type="text"
                placeholder="用户名"
                class="right"
              />
            </div>
            <!-- <input type="password" style="width:0;height:0;float:left;visibility:hidden"/> -->
            <div class="df-logmm-box-inp">
              <div class="left">
                <img src="../../image/pass.png" class="img" />
              </div>
              <input
                v-model="password"
                type="password"
                placeholder="密码"
                class="right"
                autocomplete="off"
              />
            </div>
            <div class="df-logmm-box-c">
              <span
                ><el-checkbox v-model="jizhYname">记住用户名</el-checkbox></span
              >
              <span><el-checkbox v-model="jizhYmm">记住密码</el-checkbox></span>
              <span @click="show3()">密码找回</span>
            </div>
            <div class="df-logmm-box-d">
              <input
                v-model="yccode"
                type="text"
                placeholder="请输入验证码"
                class="yzminput"
              />
              <span
                ><img :src="codeUrl" @click="getCode" class="login-code-img"
              /></span>
            </div>
            <!-- <div class="df-logmm-box-e">
              <span>更换验证码</span>
            </div> -->
            <div class="df-logmm-box-but" @click="loginBefore">登录</div>
            <div class="df-logmm-box-f">
              登录即代表同意<el-link
                :underline="false"
                type="primary"
                @click="show1()"
                :style="'color:#0063b1'"
                >《服务协议》</el-link
              >与<el-link
                :underline="false"
                type="primary"
                @click="show2()"
                :style="'color:#0063b1'"
                >《隐私政策》</el-link
              >
            </div>
          </div>
          <!--<div v-if="isRight" class="right">
          <img v-if="rightImg != ''" :src="rightImg" class="img" /><img
            v-else
            src="../../images/bg3.png"
            class="img"
          />
        </div>-->
        </div>
      </div>
      <!--<div class="bottom copyright flexStyle1">
        {{ webCopyright }}
      </div>-->
      <!-- <div class="bottom icp flexStyle1">
        备案编号：<a href="http://beian.miit.gov.cn/" target="_blank">{{
          webIcp
        }}</a>
      </div> -->
      <div class="bottom icp flexStyle1" v-html="footerHtml"></div>
      <div class="liucheng">
        <span><img src="../../image/d1.png" /></span>
        <span><img src="../../image/d2.png" /></span>
        <span><img src="../../image/d3.png" /></span>
        <span><img src="../../image/d4.png" /></span>
        <span><img src="../../image/d5.png" /></span>
        <span><img src="../../image/d6.png" /></span>
      </div>
    </div>
    <!-- 2.main-container-end -->

    <el-dialog :title="showTitle" :visible.sync="showDialog">
      <el-scrollbar style="height: 300px">
        <div
          v-html="showHtml"
          style="overflow-x: hidden; padding: 5px 10px"
        ></div>
      </el-scrollbar>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button round @click="closeShow">{{ colseText }}</el-button>
      </div></el-dialog
    >
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import {
  loginRequest,
  baseInfoRequest,
  getKeysRequest,
  getCodeImg,
} from "../../public/js/service";

import aes from "../../public/js/aes";

export default {
  data() {
    // 1.data
    return {
      username: "", // 1.1.客户名称
      password: "", // 1.2.密码
      uuid: "",
      codeUrl: "",
      title: "", // 1.3.title
      sysId: "",
      webIcp: "",
      webCopyright: "",
      footerHtml: "",
      showDialog: false,
      showHtml: "",
      colseText: "我知道了",
      showTitle: "",
      webAgreement: null,
      webPolicy: null,
      isLeft: false,
      isRight: false,
      logoImg: "",
      leftImg: "",
      rightImg: "",
      mainBg: "",
      jizhYname: false,
      jizhYmm: false,
      yccode: "",
      cozyTip:
        "温馨提示:欢迎来到开元天汇，如您遇到任何问题可以拨打客服电话400-819-***",
    };
  },

  methods: {
    getCode() {
      getCodeImg().then((res) => {
        this.codeUrl = "data:image/gif;base64," + res.img;
        this.uuid = res.uuid;
      });
    },
    // 2.methods
    register() {
      // 2.1.注册
      this.$router.push("/register");
    },

    loginBefore() {
      // 2.2.登录之前
      if (this.verifacation()) {
        this.login();
      }
    },

    verifacation() {
      // 2.3.校验表单方法
      let result = false;
      if (!this.username.trim()) {
        // 客户名称校验
        this.$notify({
          title: "提示",
          message: "请输入用户名称",
        });
      } else {
        if (!this.password.trim()) {
          // 密码校验
          this.$notify({
            title: "提示",
            message: "请输入密码",
          });
        } else {
          if (!this.yccode.trim()) {
            // 密码校验
            this.$notify({
              title: "提示",
              message: "请输入验证码",
            });
          } else {
            result = true;
          }
        }
      }

      return result;
    },
    login1() {
      if (this.sysId == "") {
        this.getBaseInfo();
      }
      if (this.sysId != "") {
        this.openLoading();
        let data = {
          username: this.username,
          password: aes.encrypt(this.password),
          sysId: Number(this.sysId),
          uuid: this.uuid,
          code: this.yccode,
          ckeck: "0",
        };
        loginRequest(data).then((res) => {
          this.closeLoading();
          console.log(res);
          if (res) {
            let r = res.token;
            if (r) {
              localStorage.token = r;
              localStorage.loginStatus = 1;
              if (this.jizhYname) {
                localStorage.setItem("username", this.username);
              } else {
                localStorage.setItem("username", "");
              }
              if (this.jizhYmm) {
                localStorage.setItem("password", this.password);
              } else {
                localStorage.setItem("password", "");
              }
              this.$router.push("/goodsCenter");
            } else {
              this.getCode();
            }
          } else {
            this.getCode();
          }
        });
      }
    },
    login() {
      // 2.4.登录请求
      if (this.sysId == "") {
        this.getBaseInfo();
      }
      if (this.sysId != "") {
        this.openLoading();
        let data = {
          username: this.username,
          password: aes.encrypt(this.password),
          sysId: Number(this.sysId),
          uuid: this.uuid,
          code: this.yccode,
          ckeck: "1",
        };
        loginRequest(data)
          .then((res) => {
            this.closeLoading();
            if (res) {
              if (res.code == 201) {
                this.$confirm(res.msg, "登录提示", {
                  confirmButtonText: "登录",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    this.login1();
                  })
                  .catch(() => {});
              } else {
                let r = res.token;
                if (r) {
                  localStorage.token = r;
                  localStorage.loginStatus = 1;
                  if (this.jizhYname) {
                    localStorage.setItem("username", this.username);
                  } else {
                    localStorage.setItem("username", "");
                  }
                  if (this.jizhYmm) {
                    localStorage.setItem("password", this.password);
                  } else {
                    localStorage.setItem("password", "");
                  }
                  this.$router.push("/goodsCenter");
                } else {
                  this.getCode();
                }
              }
            } else {
              this.getCode();
            }
          })
          .catch(() => {
            this.getCode();
          });
      }
    },
    closeShow() {
      this.showDialog = false;
    },
    show1() {
      this.showTitle = "《服务协议》";
      this.colseText = "关闭本页";
      this.showDialog = true;
      let data = {};
      data.searchValue = "web_agreement";
      data.sysId = this.sysId;
      if (Number(this.sysId) > 0) {
        getKeysRequest(data).then((res) => {
          if (res) {
            let r = res.data[0];
            this.showHtml = r.web_agreement || "";
          }
        });
      }
    },
    show2() {
      this.showTitle = "《隐私政策》";
      this.colseText = "我知道了";
      this.showDialog = true;
      let data = {};
      data.searchValue = "web_policy";
      data.sysId = this.sysId;
      if (Number(this.sysId) > 0) {
        getKeysRequest(data).then((res) => {
          if (res) {
            let r = res.data[0];
            this.showHtml = r.web_policy || "";
          }
        });
      }
    },
    show3() {
      this.showTitle = "《说明》";
      this.colseText = "我知道了";
      this.showDialog = true;
      let data = {};
      data.searchValue = "web_backPwd";
      data.sysId = this.sysId;
      if (Number(this.sysId) > 0) {
        getKeysRequest(data).then((res) => {
          if (res) {
            let r = res.data[0];
            this.showHtml = r.web_back_pwd || "请联系销售人员重置密码！";
          }
        });
      }
    },
    pageEnterKeyWatch() {
      // 2.5.页面回车监听
      let _this = this;
      let psw = this.$refs["paswd"];
      psw.addEventListener("keydown", (event) => {
        // 2.5.1.页面监听回车事件
        var key = event.keyCode;
        if (key == 13) {
          _this.loginBefore();
        }
      });
    },

    getBaseInfo() {
      localStorage.removeItem("loginStatus");
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");

      // 2.6.获取站点基础信息
      let url = window.location.hostname;
      if (
        url == "192.168.1.34" ||
        url == "120.55.13.213" ||
        url == "bbbb.df.guoxinzulin.com" ||
        url == "localhost"
      ) {
        url = "bbbb.df.vue.waiwubang.com";
        url = "01.daifa.zhongliangec.com";
      }

      baseInfoRequest(url).then((res) => {
        if (res) {
          let r = res.data[0];
          this.title = r.web_name || "";
          this.sysId = r.sys_id || "";
          this.webIcp = r.web_icp || "";
          this.webIcpHtml = r.web_icp_html || "";

          this.webGs = r.web_gs || "";
          this.webGsHtml = r.web_gs_html || "";

          this.logoImg = r.web_logo_login || "";
          if (this.webIcpHtml) {
            this.footerHtml += " " + this.webIcpHtml;
          } else {
            if (this.webIcp) {
              this.footerHtml +=
                '备案编号：<a href="https://beian.miit.gov.cn/" target="_blank">' +
                this.webIcp +
                "</a>";
            }
          }
          let simg =
            '<img style="width:20px;height:20px;margin-left:10px;" src="https://kaiyuan-back-file.oss-cn-beijing.aliyuncs.com/profile/upload/20251201/ab28e432cb3c4369b3f12c45b0844d5d.png"/>';
          if (this.webGsHtml) {
            this.footerHtml += this.webGsHtml;
          } else {
            if (this.webGs) {
              let regex2 = /\d+/;
              let r2 = this.webGs.match(regex2)?.[0];
              this.footerHtml +=
                ' <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=' +
                r2 +
                '" target="_blank" rel="noreferrer">' +
                simg +
                this.webGs +
                "</a>";
            }
          }

          this.bgImg = r.web_login_bg || "";
          this.leftImg = r.web_login_left || "";
          this.rightImg = r.web_login_right || "";

          this.cozyTip = r.web_cozy_tip || "";

          if (this.bgImg != "") {
            this.mainBg =
              "background: url(" + this.bgImg + ") no-repeat center 0;";
          }

          this.webCopyright = r.web_copyright || "";

          localStorage.baseInfo = JSON.stringify(r);
          window.document.title = r.web_title;
        }
      });
    },

    openLoading() {
      // 2.7.打开加载遮罩层
      this.loadingInstance = this.$loading.service({
        fullscreen: true,
        lock: true,
      });
    },

    closeLoading() {
      // 2.8.关闭遮罩层
      this.loadingInstance.close();
    },
  },
  created() {
    this.username = localStorage.getItem("username") || "";
    this.password = localStorage.getItem("password") || "";
    if (this.username != "") {
      this.jizhYname = true;
    }
    if (this.password != "") {
      this.jizhYmm = true;
    }
    this.getCode();
  },
  mounted() {
    // 3.mounted
    this.getBaseInfo();
    //this.pageEnterKeyWatch();
  },
};
</script>
<style scoped lang="scss">
@import "./login.scss";
</style>
<style lang="scss">
.el-scrollbar .el-scrollbar__wrap {
  overflow-x: hidden;
}
.el-select-dropdown .el-scrollbar {
  padding-bottom: 17px;
}
</style>
